export class CollectionTypeParams {
    constructor(
        public orderTypeId: number = null,
        public address: APICommon.GooglePlaceDetails = null,
        public tableNo: string = null
    ) { }
}
